<template>
  <div :class="['login-wrap', { 'login-wrap-117': is117 , 'login-wrap-shizheng': isshizheng, 'login-wrap-english': isEnglish }]">
    <marquee>您好！非常抱歉地通知您，为给您提供更优质、更稳定的服务体验，平台将于 2025 年 7 月 5 日 00：00 开始进行服务器整体升级，在此期间平台将暂停运营，预计持续 8 - 10 小时。
      此次升级旨在提升平台的性能与功能，以满足您不断增长的需求。升级完成后，您将享受到更流畅的操作流程、更丰富的服务内容以及更安全可靠的数据保障。
      对于此次暂停运营给您带来的不便，我们深表歉意。感谢您一直以来对平台的支持与信任，您的理解是我们不断前进的动力。
      如有任何疑问或需要帮助，请随时与我们的客服团队联系。
      再次感谢您的耐心等待，期待以更好的姿态与您相见！</marquee>
    <div class="copyright">
      <p>技术支持单位：北京建科研软件技术有限公司</p>
      <p>网址：http://www.jiankeyan.com</p>
      <p>电话：010-64405889</p>
    </div>
    <img
      v-show="lang == '中文'"
      class="bg-name"
      :src="bgName"
    />
    <img
      v-show="lang == 'English'"
      class="bg-name"
      src="@/assets/img/english.png"
    />
    <div class="login-input">
      <div
        @click="languageChange"
        class="language"
      >
        <img
          v-if="lang == '中文'"
          src="@/assets/img/login_cn.png"
        />
        <img
          v-else
          src="@/assets/img/login_en.png"
        />
      </div>
      <img
        @click="isShowDownload=true"
        class="download_icon"
        src="@/assets/img/downloadqr.png"
      />
      <div
        v-show="isShowDownload"
        @click="isShowDownload=false"
        class="login-input download_wrap"
      >
        <div class="download_content">
          <div class="download_pic">
            <img src="@/assets/img/android.png" />
            <img src="@/assets/img/ios.png" />
          </div>
          <div class="download_logo">
            <img src="@/assets/img/android_icon.png" />
            <img src="@/assets/img/ios_icon.png" />
          </div>
          <div class="download_text">{{$t('downloadqrcode')}}</div>
        </div>

      </div>

      <div class="input-title row-center">{{$t('welcomtologin')}}</div>
      <div class="input-wrap">
        <el-input
          :placeholder="$t('placeholderUserName')"
          v-model="userName"
        >
          <i slot="prefix">
            <img src="@/assets/img/login-user-icon.png" />
          </i>
        </el-input>
        <el-input
          :placeholder="$t('placeholderPassword')"
          v-model="userPwd"
          class="pwd"
          show-password
        >
          <i slot="prefix">
            <img src="@/assets/img/login-pwd-icon.png" />
          </i>
        </el-input>
        <el-input
          :placeholder="$t('placeholderCode')"
          v-model="verificationCode"
          @keyup.enter.native="clickLogin(false)"
          class="code"
        >
          <i slot="prefix">
            <img
              class="codeImg"
              src="@/assets/img/login-user-code.png"
            />
          </i>
          <img
            class="codeImgNumber"
            slot="suffix"
            @click="getImage()"
            :src="codeImg"
            alt="验证码"
          />
        </el-input>
        <el-button
          class="btn-login"
          type="primary"
          @click="clickLogin(false)"
          :disabled="disabled"
        >{{ loginMsg }}</el-button>
        <!-- <span
          @click="clickLogin(true)"
          class="test-btn-login"
        > 测试入口</span> -->
        <!-- <div
          class="btn-login"
          @click="clickLogin"
        >登录
        </div> -->
      </div>
    </div>
    <CheckPhoneNUmber
      ref="checknumber"
      @check="checkPhone"
    />
  </div>
</template>
<script>
import CheckPhoneNUmber from './CheckNumber.vue'
import { Api_login } from "@/api/api";
import { setStore } from "@/util/store";
import { PROJECT_URL, COMPANY_URL } from "@/util/constant.js";
import to from "await-to-js";
import { BASE_URL, BASE_URL_HOME } from "@/util/constant";
import platFormLogo from "@/assets/img/logo.png";

// import errorImage from "@/assets/img/error-bg-name.png";

const SUPER_ADMIN = 1; // 超级管理员 jky2021  666666
const COMPANY_ADMIN = 2; // 公司管理员(公司用户跳转到选择公司列表，然后进首页) 前端专用 666666
const BRANCH_COMPANY_ADMIN = 3; // 分公司管理员
const PROJECT_ADMIN = 4; // 项目管理员 前端项目 666666
const UNIT_ADMIN = 5; // 参建单位管理员（跳转到后台，和项目权限一样，去掉参建单位tab） 参建单位 666666
const THIRD_PART_ADMIN = 6; // 第三方管理员(和参建单位一样)
const COMPANY_USER = 7; // 公司人员
const PROJECT_USER = 8; // 项目人员
const UNIT_USER = 9; // 参建单位人员
const THIRD_PART_USER = 10; // 第三方人员
const other_USER = 11; // 其他人员
const EXAM_USER = 12; // 安全教育人员
export default {
  data: () => ({
    userName: "",
    userPwd: "",
    companyId: 0,
    userId: 0,
    projectId: 0,
    accessToken: "",
    disabled: false,
    loginMsg: "登录",
    // bgName: require(`../../assets/img/${process.env.npm_config_ip}.png`),
    bgName: (() => {//114用 117logo
      const ip = process.env.npm_config_ip;
      if (ip == '114.116.12.146') {
        return require(`../../assets/img/117.78.39.56.png`);
      }
      return require(`../../assets/img/${ip}.png`);
    })(),
    guid: null,
    codeImg: "",
    verificationCode: null,
    is114: false,
    is117: false, // 是否是117平台
    isshizheng: false, // 是否是市政
    isEnglish: false, // 是否翻译背景图
    phoneNumber: '',
    isShowDownload: false,
    testLogin: false,
    isCheck: false,//二次验证逻辑
    email: '',
    lang: '中文'
  }),
  watch: {
    "$i18n.locale"(val) {
      if (val) {
        this.loginMsg = this.$t('login')
      }
    },
  },
  components: {
    CheckPhoneNUmber
  },
  mounted() {
    this.is114 = window.location.hostname == "114.116.12.146" || window.location.hostname == 'localhost';
    this.is117 = window.location.hostname === "117.78.39.56" || window.location.hostname === "39.107.193.85" || window.location.hostname == "114.116.12.146" || window.location.hostname == 'localhost';//114也用 117背景图
    this.isshizheng = window.location.hostname === "114.242.213.194";
    Api_login.logout();
    this.userName = localStorage.getItem("jky-admin-acount") || null;
    this.userPwd = localStorage.getItem("jky-admin-pwd") || null;

    this.getImage();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    languageChange(value) {
      setStore({ name: 'language', content: value });
      this.lang = this.lang == '中文' ? 'English' : '中文';//文本
      this.$i18n.locale = this.lang == '中文' ? 'zh' : 'en';
      this.isEnglish = this.lang == '中文' ? false : true;
    },
    handleResize() {
      // 处理窗口大小变化的逻辑
      let bodyWidth = document.getElementsByTagName('body')[0].clientWidth
      let bodyHeight = document.getElementsByTagName('body')[0].clientHeight
      document.getElementsByClassName('login-wrap ')[0].style.width = bodyWidth + 'px'
      document.getElementsByClassName('login-wrap ')[0].style.height = bodyHeight + 'px'
    },
    // 随机数
    rand(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    // 验证码图片
    getImage() {
      this.guid = this.rand(1000, 9999);
      this.verificationCode = null;
      Api_login.GetVerificationCode(this.guid).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.codeImg = res.url;
        }
      });
    },
    async clickLogin(bool) {
      this.testLogin = bool;//true为改版新项目首页
      this.disabled = true;
      this.loginMsg = this.$t('loggingin') || "登录中";
      const { verificationCode, guid } = this;

      const params = {
        userAccount: this.userName,
        pwd: this.userPwd,
        guid,
        verificationCode,
      };

      const [err, response] = await to(Api_login.login(params));
      this.disabled = false;
      this.loginMsg = this.$t('login') || "登录";
      if (err) {
        this.getImage();
        return;
      }
      if (!response) {
        this.getImage();
        this.userName = null;
        this.userPwd = null;
        this.disabled = false;
        return;
      }
      if (response.data.statusCode !== 200) {
        if (response.data.errors && response.data.errors.includes("用户名或密码错误")) {
          this.userName = null;
          this.userPwd = null;
        }

        this.getImage();
        this.$message({
          type: "error",
          message: response.data.errors,
        });
        return;
      } else {
        localStorage.setItem("jky-admin-acount", this.userName);
        localStorage.setItem("jky-admin-pwd", this.userPwd);
        this.buryPointData(response.data.data);
      }
    },
    async buryPointData(resData) {
      let params = {
        moduleId: null,
        moduleName: null,
        logType: "0001-0000-0001",
        extendJson: "",
        origin: 1,
      };
      const [err, { data: result }] = await to(Api_login.buryPoint(params));
      console.log(result, "埋点");
      if (err) return;
      // this.$store.commit("setUserInfo", result.data);
      // 兼容旧的逻辑
      this.companyId = resData.companyId;
      this.userId = resData.id;
      this.projectId = resData.projectId;
      this.accessToken = resData.accessToken;
      setStore({ name: "projectId", content: this.projectId });
      setStore({ name: "companyId", content: this.companyId });
      setStore({ name: "account", content: resData.account });
      setStore({ name: "userId", content: resData.id });
      setStore({ name: "projectName", content: resData.projectName });
      setStore({ name: "userType", content: resData.userType });
      setStore({ name: "accessToken", content: resData.accessToken });
      this.phoneNumber = resData.telephone;
      this.email = resData.email;

      //账号整合  登录验证手机号  去掉验证-> 改为 管理后台添加账号时需要强制要求手机号必填
      // let IsNumber = await this.checkPhoneNumber();
      // if (!IsNumber) {
      //   this.$refs.checknumber.open();
      //   return
      // }
      //手机号二次验证
      if (resData.isSecondConfig && resData.currentLoginIsCheck) {
        this.$refs.checknumber.open({ phoneNumber: this.phoneNumber, type: "phone", code: '', email: this.email, emailCode: '' }, this.$i18n.locale);
        return
      }
      this.showModular(resData);
      // 目前不需要调用首页底部菜单接口，暂时没有这种使用场景（首页菜单长度为1 直接跳转到对应模块）
      // this.getBarMenus(result.data)
      this.getUserInfo(this.userId, resData.userType);
      // this.$store.dispatch('getUserInfo')
    },
    async getUserInfo(userId, userType) {
      const [err, { data: result }] = await to(Api_login.userInfo(userId));
      if (err) return;
      // 超级管理员默认公司自己logo
      if (userType == SUPER_ADMIN) {
        result.data.platFormName = "建科研智慧建造平台";
        result.data.platFormLogo = platFormLogo;
      } else {
        result.data.platFormLogo = BASE_URL + result.data.platFormLogo;
      }
      this.$store.commit("setUserInfo", result.data);
    },
    //手机号二次验证
    checkPhone() {
      this.isCheck = true;
    },
    async checkPhoneNumber() {
      const { data } = await Api_login.checkNumber(this.phoneNumber || 0);
      if (data.statusCode == 200) {
        return data.data;
      }
    },

    goNextPage(data) {
      // 跳转到 安全教育 - 人员端
      if (data.userType === EXAM_USER) {
        window.location.href = process.env.npm_config_domin ? `${process.env.npm_config_domin}:8901?userId=${data.id}&companyId=${data.companyId}&projectId=${data.projectId}&userType=${data.userType}` : `http://${process.env.npm_config_ip}:8901?userId=${data.id}&companyId=${data.companyId}&projectId=${data.projectId}&userType=${data.userType}`;
        return;
      }

      if (data.userType === PROJECT_USER) {
        if (this.testLogin) {
          window.location.href = `${BASE_URL_HOME}`;
        } else {
          window.location.href = `${PROJECT_URL}?userId=${data.id}&companyId=${data.companyId}&projectId=${data.projectId}&userType=${data.userType}&language=${this.$i18n.locale}`;
        }
      } else if (data.userType === COMPANY_USER) {
        // this.getCompanyList(data);
        window.location.href = `${COMPANY_URL}?userId=${data.id}&companyId=${data.companyId}&projectId=${0}&userType=${data.userType}`;
      }
    },
    // 获取公司列表
    getCompanyList(data) {
      this.$router.push({
        path: "/selectgroup",
        query: {
          userType: data.userType,
          companyId: data.companyId,
          userId: data.id,
          projectId: data.projectId,
          projectName: data.projectName,
        },
      });
    },
    // 获取首页菜单
    getBarMenus(data) {
      Api_login.getBarMenus(data.id)
        .then((res) => {
          this.disabled = false;
          this.loginMsg = this.$t('login') || "登录";
          const result = res.data;
          if (result.statusCode == 200) {
            // 首页菜单长度为1 直接跳转到对应模块,否则根据权限判断进入不同页面
            if (
              result.data &&
              result.data.length === 1 &&
              result.data[0].list.length === 1
            ) {
              window.location.href = `${result.data[0].list[0].menuUrl}?userId=${data.id}&companyId=${data.companyId}&projectId=${data.projectId}`;
            } else {
              this.showModular(data);
            }
          }
        })
        .catch(() => {
          this.disabled = false;
          this.loginMsg = "登录";
        });
    },
    /**
     * @description: 根据用户权限类型判断，不同权限跳转到不同页面
     * @param {*} data
     * @return {*}
     */
    showModular(data) {
      //1:动火管理员 2:动火作业员
      // if (data.fireWorkType == 2) {//直接进入动火作业员
      //   window.location.href = `http://${process.env.npm_config_ip}:8834?userId=${data.id}&companyId=${data.companyId}&projectId=${data.projectId}`;
      //   return;
      // } else if (data.limitSpaceType == 2) {   //1:密闭空间管理员 2:密闭空间作业员
      //   window.location.href = `http://${process.env.npm_config_ip}:8836?userId=${data.id}&companyId=${data.companyId}&projectId=${data.projectId}`;
      //   return
      // } else {
      switch (data.userType) {
        case SUPER_ADMIN: // 超级管理员
          this.$router.push({ path: "/superadmincompany" });
          break;
        case COMPANY_ADMIN: // 公司管理员
          this.$router.push({ path: "/groupinfo" });
          break;
        case BRANCH_COMPANY_ADMIN: // 分公司管理员
          this.$router.push({ path: "/groupinfo" });
          break;
        case PROJECT_ADMIN: // 项目管理员
          this.$router.push({ path: "/projectmanager" });
          break;
        case UNIT_ADMIN: // 参建单位管理员
          this.$router.push({ path: "/unitdepart" });
          break;
        case THIRD_PART_ADMIN: // 第三方管理员
          // TODO 前端未开发,暂时没有相应权限的人员
          break;
        case COMPANY_USER: //  公司人员
          this.goNextPage(data);
          break;
        case PROJECT_USER: //  项目人员
          this.goNextPage(data);
          break;
        case UNIT_USER: //  参建单位人员
          // TODO 前端未开发,暂时没有相应权限的人员
          break;
        case THIRD_PART_USER: //  第三方人员
          // TODO 前端未开发,暂时没有相应权限的人员
          break;
        case other_USER: //  其他人员
          break;
        case EXAM_USER: //  安全教育人员
          // TODO 测试安全教育，测完删除调用项目方法
          this.goNextPage(data);
          break;
        default:
      }
      // }
    },
  },
};
</script>
<style lang="scss">
.login-wrap {
  width: 100%;
  // height: 100%;
  background: url(../../assets/img/login-bg.png) no-repeat center 0;
  background-size: 100% 100%;
  min-height: 700px;
  position: relative;
  marquee {
    position: absolute;
    padding-top: 6px;
    display: none;
  }
  .copyright {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 48px;
    line-height: 48px;
    color: white;
    display: flex;
    justify-content: center;
    font-size: 15px;
    background: rgba(0, 0, 0, 0.4);
    display: none;
    p {
      margin: 0 24px;
    }
  }
  .bg-name {
    margin: 0 auto;
    display: block;
    padding-top: 40px;
    height: 114px;
  }

  .login-input {
    width: 500px;
    height: 450px;
    background: url(../../assets/img/login-input-bg.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    left: 60%;
    top: 6.5%;
    .language {
      position: absolute;
      left: 16px;
      top: 12px;
      cursor: pointer;
    }
    .download_icon {
      position: absolute;
      right: 6px;
      top: 6px;
      cursor: pointer;
    }
    .download_wrap {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 99;
      .download_content {
        text-align: center;
        color: #fff;
        .download_pic {
          padding: 120px 0 20px 0;

          img {
            margin: 0 15px;
            width: 120px;
            padding: 15px;
            border: 1px solid #fff;
            border-radius: 8px;
          }
        }
        .download_logo {
          margin: 20px 0;
          img {
            margin: 0 65px;
            vertical-align: middle;
          }
        }
        .download_text {
          width: 75%;
          margin: 0 auto;
        }
      }
    }
  }

  .input-title {
    font-size: 40px;
    padding-top: 40px;
    display: flex;
    justify-content: center;
    height: 92px;
    box-sizing: border-box;
  }

  .input-wrap {
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 50px;

    .el-input__prefix {
      display: flex;
      align-items: center;
    }

    .el-input__inner {
      background: #fff;
      color: #333;
      border-radius: 5px;
    }
  }

  .pwd {
    margin-top: 30px;
  }

  .btn-login {
    width: 100%;
    text-align: center;
    font-size: 22px;
    background: #48bdd1;
    margin: 50px auto 0;
    border-radius: 5px;
    padding: 10px 0;
    cursor: pointer;
    border: 0;
  }

  .input-wrap {
    .el-button--primary.is-disabled:hover {
      background: #48bdd1;
      border-color: #48bdd1;
    }
  }

  .code {
    margin-top: 30px;
    .codeImgNumber {
      width: 100px;
    }
    .codeImg {
      height: 18px;
    }
  }
}
.login-wrap-117 {
  background: url(../../assets/img/login-bg-117.png) no-repeat center center;
  background-size: 100% 100%;
}
.login-wrap-shizheng {
  background: url(../../assets/img/login-bg-shizheng.png) no-repeat center
    center;
  background-size: 100% 100%;
}
.login-wrap-english {
  background: url(../../assets/img/login-bg-english.png) no-repeat center center;
  background-size: 100% 100%;
}
.test-btn-login {
  position: absolute;
  bottom: 36px;
  font-size: 12px;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
